import React, { useState, useEffect } from 'react'
import { NavLink, Link } from 'react-router-dom'
import './HomeNavigation.css'
import { FaSyncAlt } from 'react-icons/fa'
import HomeHeader from './HomeHeader'
import HomeNavLinks from './HomeNavLinks'
import SideDrawer from '../../../admin/components/SideDrawer'
import Backdrop from '../UIElements/Backdrop'
import schedulesLogo from '../../../images/schedules_transparent.png'

const SchedulesHomeNavigation = (props) => {
	const [drawerIsOpen, setDrawerIsOpen] = useState(false)

	const [isViewingInApp, setIsViewingInApp] = useState(false)

	useEffect(() => {
		const detectApp = () => {
			const hasNativeAppBridge =
				typeof window.makeInAppPurchase === 'function' ||
				typeof window.restorePurchases === 'function' ||
				typeof window.isInCustomTab === 'function'

			setIsViewingInApp(hasNativeAppBridge)
		}

		if (typeof window.executeWhenAppReady === 'function') {
			window.executeWhenAppReady(() => {
				detectApp()
			})
		} else {
			detectApp()
		}
	}, [])

	const openDrawerHandler = () => {
		setDrawerIsOpen(true)
	}

	const closeDrawerHandler = () => {
		setDrawerIsOpen(false)
	}

	const refreshPageHandler = () => {
		window.location.reload()
	}

	return (
		<React.Fragment>
			{drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
				<nav className='home-navigation__drawer-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</SideDrawer>
			<HomeHeader>
				<button
					className='home-navigation__menu-btn'
					onClick={openDrawerHandler}
				>
					<span />
					<span />
					<span />
				</button>
				<div className='headerWidth'>
					<img src={schedulesLogo} className='standingsLogo' />
				</div>
				<nav className='home-navigation__header-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
				{isViewingInApp && (
					<button
						type='button'
						className='home-navigation__refresh-btn'
						onClick={refreshPageHandler}
						aria-label='Refresh'
						title='Refresh'
					>
						<FaSyncAlt />
					</button>
				)}
			</HomeHeader>
			{/* <SelectLeague /> */}
		</React.Fragment>
	)
}

export default SchedulesHomeNavigation
